import { Tabs } from '@mantine/core';

import { useTranslation } from '@apple/lib/i18next';
import type { CountryOption, TimeZoneOption } from '@apple/utils/globalization/models';

import type { ChangePasswordRequest, UpdateProfileRequest } from '@apple/features/auth/models/user';
import type { Profile } from '@apple/features/auth-retail/models/user';
import { ChangePassword } from '@apple/features/user/components/ChangePassword';
import { ProfileForm } from '@apple/features/user/components/ProfileForm';

export type AccountSettingsProps = {
	profile: Profile;
	timeZones: TimeZoneOption[];
	countries: CountryOption[];
	updateProfile: (request: UpdateProfileRequest) => Promise<void>;
	changePassword: (request: ChangePasswordRequest) => Promise<void>;
};

export function AccountSettings({
	profile,
	countries,
	timeZones,
	updateProfile,
	changePassword,
}: AccountSettingsProps) {
	const { t } = useTranslation('profile');

	return (
		<Tabs defaultValue='profile'>
			<Tabs.List>
				<Tabs.Tab value='profile'>{t('tabs.userProfile')}</Tabs.Tab>
				<Tabs.Tab value='change-password'>{t('tabs.passwordReset')}</Tabs.Tab>
			</Tabs.List>
			<Tabs.Panel value='profile'>
				<ProfileForm
					profile={profile}
					onSubmit={updateProfile}
					timeZones={timeZones}
					countries={countries}
				/>
			</Tabs.Panel>
			<Tabs.Panel value='change-password'>
				<ChangePassword onSubmit={changePassword} />
			</Tabs.Panel>
		</Tabs>
	);
}
